import { render, staticRenderFns } from "./CustomMapSimple.vue?vue&type=template&id=bcd9e70c&scoped=true"
import script from "./CustomMapSimple.vue?vue&type=script&lang=js"
export * from "./CustomMapSimple.vue?vue&type=script&lang=js"
import style0 from "./CustomMapSimple.vue?vue&type=style&index=0&id=bcd9e70c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd9e70c",
  null
  
)

export default component.exports